import * as React from "react";
import Tippy from "@tippy.js/react";
import { useLocalStore, observer } from "mobx-react";
import OutsideClickHandler from "react-outside-click-handler";
import { Fragment } from "react";
import { CommandCentreVenue } from "../../state/UserState";

type VenuesDropMenuProps = {
  isSingleVenue: boolean;
  selectedVenue?: CommandCentreVenue;
  userVenues?: CommandCentreVenue[];
  totalVenueCount: number;
  selectVenue: (venue: CommandCentreVenue) => void;
  venueSearchTerm?: string;
  updateVenueSearchTerm: (venueSearchTerm: string) => void;
};

export const VenuesDropMenu = observer((props: VenuesDropMenuProps) => {
  const searchBoxRef = React.useRef<HTMLInputElement>(null);
  const { selectedVenue } = props;

  const localState = useLocalStore(() => ({
    isOpen: false,
  }));

  const itemSelected = (venue: CommandCentreVenue) => {
    localState.isOpen = false;
    props.selectVenue(venue);
  };

  const toggleVenueList = () => {
    localState.isOpen = !localState.isOpen;

    if (localState.isOpen && searchBoxRef.current) {
      setTimeout(() => {
        searchBoxRef.current?.focus();
      }, 100);
    }
  };

  if (props.isSingleVenue) {
    return (
      <div className="w-max flex flex-row gap-2 hover:shadow-2xl p-2 rounded-full hover:text-gray-400 dark:hover:text-gray-300">
        <img
          className="w-10 h-10 rounded-xl object-cover"
          src={props.selectedVenue?.commCenAppIconUrl}
          alt=""
        />
        <div className="flex items-center gap-4 ">
          <div className="font-medium dark:text-white hover:color-gray-400 ">
            <div>{`${props.selectedVenue?.displayName}`}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <OutsideClickHandler onOutsideClick={() => (localState.isOpen = false)}>
      <Tippy
        content={
          <Fragment>
            <div
              id="dropdownSearch"
              className="z-10 bg-white rounded-lg shadow w-60 dark:bg-gray-700"
            >
              <div className="p-3">
                <label htmlFor="input-group-search" className="sr-only">
                  Search
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 rtl:inset-r-0 start-0 flex items-center ps-3 pointer-events-none"></div>
                  <input
                    value={props.venueSearchTerm}
                    onChange={(event) =>
                      props.updateVenueSearchTerm(
                        event.target.value.toLowerCase()
                      )
                    }
                    type="text"
                    id="input-group-search"
                    className="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 "
                    placeholder="Search Venue"
                  />
                </div>
              </div>
              <ul
                className="h-72 overflow-y-auto text-sm text-gray-700 dark:text-gray-200"
                aria-labelledby="dropdownSearchButton"
              >
                {props.userVenues?.map((venue) => (
                  <li
                    key={venue.venueId}
                    onClick={() => itemSelected(venue)}
                    className="hover:bg-gray-50 cursor-pointer px-4 items-center rounded-lg transition-all min-h-20 min-w-20 flex gap-2"
                  >
                    <div className="w-10 h-10 rounded-xl bg-gray-200">
                      <img
                        className="w-10 h-10 rounded-xl object-cover"
                        src={venue.commCenAppIconUrl}
                        alt=""
                        loading="lazy"
                        onError={(e: any) => {
                          e.currentTarget.style.display = "none";
                        }}
                      />
                    </div>

                    <h3 className="text-lg tracking-tight text-gray-900 dark:text-white">
                      {venue.displayName}
                    </h3>
                  </li>
                ))}
              </ul>
            </div>
          </Fragment>
        }
        placement="bottom"
        animation="scale-subtle"
        theme="material"
        arrow={true}
        duration={200}
        delay={[75, 0]}
        distance={8}
        interactive={true}
        visible={localState.isOpen}
      >
        <div
          onClick={toggleVenueList}
          className="flex items-center gap-2 font-medium cursor-pointer hover:shadow-2xl p-2 rounded-xl transition-all "
        >
          <img
            className="w-10 h-10 rounded-xl object-cover"
            src={props.selectedVenue?.commCenAppIconUrl}
            alt={""}
          />
          <div className="flex items-center gap-4 font-medium hover:color-gray-400">
            {props.selectedVenue?.displayName}
          </div>
        </div>
      </Tippy>
    </OutsideClickHandler>
  );
});
